import * as _uniqBy from 'lodash/uniqBy';

export function uniqBy<T>(values: T[], iteratee: any): T[] {
  return _uniqBy(values, iteratee);
}
